import { render } from "./App.vue?vue&type=template&id=b7e9813a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=b7e9813a&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c68acb88b8efab7cfd13739edd187441/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__